<template>
    <div id="org-container">
        <label class="message" v-if="isComponentLoaded == false">{{__("misc.loading")}}</label>
        <label class="message" v-if="nodes == '' && isComponentLoaded == true">{{__("errors.userPermission.500.noNodes")}}</label>
        <div id="tree" ref="tree"></div>
    </div>
</template>

<script>

    import OrgChart from './orgChart/orgchart.js'
    OrgChart.templates.isla.size=[180,140]; //180,120

    OrgChart.templates.isla.field_1 ="<text width='160' style='font-size: 13px;' text-overflow='multiline' fill='#039BE5' x='90' y='64' text-anchor='middle' >{val}</text>"
    OrgChart.templates.isla.field_0 ="<text width='120' style='font-size: 12px;' fill='#fff' x='90' y='110' text-anchor='middle'>{val}</text>"
    OrgChart.templates.isla.node = '' +
        '<rect filter="url(#isla-shadow)" x="0" y="20" rx="5" ry="5" height="120" width="180" fill="#FFF" stroke-width="1" stroke="#039BE5" ></rect>' +
        '<rect x="25" y="95" rx="10" ry="10" height="20" width="130" fill="#039BE5" stroke-width="3" stroke="#039BE5"></rect>' +
        '<rect fill="#ffffff" stroke="#039BE5" stroke-width="1" x="70" y="0" rx="13" ry="13" width="40" height="40"></rect>' +
        '<circle stroke="#FFCA28" stroke-width="3" fill="none" cx="90" cy="12" r="8"></circle>' +
        '<path d="M75,34 C75,17 105,17 105,34" stroke="#FFCA28" stroke-width="3" fill="none"></path>'

    export default {

        name: 'tree',
        data() {
            return {
                configuration: {
                    template: "isla",
                    collapse: {
                            level: this.first_collapse,
                            allChildren: true
                        },
                    clinks: [],
                    enableDragDrop: false,
                    menu: {
                        export_pdf: {
                            text: "Export PDF",
                            icon: OrgChart.icon.pdf(24, 24, "#7A7A7A"),
                            onClick: this.pdf
                        },

                        reset_org_chart: {
                          text: "Reset orgChart",
                          onClick: this.resetChart,
                          icon: OrgChart.icon.details(24,24, "#7A7A7A"),
                        },
                        preview : {
                          text: "Stampa Preview",
                          onClick: this.previewPrint,
                          icon: OrgChart.icon.png(24,24, "#7A7A7A"),
                        }
                    },
                    tags: {
                        "assistant": {
                            template: "isla"
                        }
                    },
                    nodeBinding: {
                        field_0: "name",
                        field_1: "title",
                        img_0: "img",
                        field_number_children: "field_number_children",

                    },
                  nodeMenu: {
                        open_alone: {
                            icon: "",
                            text: "Open Alone",
                            onClick: this.openAlone
                        },
                    },
                },
                nodes: [],
                clinks: [],
                isComponentLoaded: Boolean
            }
        },
        methods: {
            getChildsPerNode: function (parentNodeId) {
                let children = [];
                for (var i = 0; i < this.nodes.length; i++) {
                    if (this.nodes[i].pid === parentNodeId) {
                        children.push(this.nodes[i]);
                    }
                }
                return children;
            },
            openAlone: function(nodeId) {
                window.open(this.base_url+"?alone="+nodeId,"_blank");
            },
            pdf: function() {
                window.open(this.print_all_url,"_blank");
            },
            resetChart : function (){
                window.open(this.base_url);
            },
            previewPrint : function (){
              OrgChart.pdfPrevUI.show(this.chart, {
                format: "A4",
                header: 'OrgChart',
                footer: ' {current-page} of {total-pages}'
              });
            },
            renderChart: function(domEl, nodes, clinks) {
                let configuration = this.configuration;
                for (var i = 0; i < nodes.length; i++) {

                    nodes[i].field_number_children = this.getChildsPerNode(nodes[i].id).length;
                }
                configuration.nodes = nodes;
                configuration.clinks = clinks;
                let detailsUrl = this.details_url;

                this.chart = new OrgChart(domEl, this.configuration);
                this.chart.on('click', function(sender, args){
                let urlTo = detailsUrl+"&item="+args.node.id;
                  app.__vue__.$refs.vue_sidebar.toggle(decodeURI(urlTo));
                  return false; //to cansel the click event
                });
            },
            getNodes: function() {
                
                let aloneUrl = (this.alone_root > 0) ? "?alone="+this.alone_root : "";
                if(this.project === undefined) {
                    axios.get('/get-orgchart'+aloneUrl)
                        .then((response) => {
                            this.nodes = response.data.nodes;
                            this.clinks = response.data.clinks;
                            this.renderChart(this.$refs.tree, this.nodes, this.clinks)
                        });
                }
                else if( this.project === "role"){
                    axios.get('/get-orgchart-role'+aloneUrl)
                        .then((response) => {
                        this.nodes = response.data.nodes;
                        this.renderChart(this.$refs.tree, this.nodes)
                        });
                }else if(this.project == "organizationalUnit"){
                    axios.get('/get-orgchart-orgunit'+aloneUrl)
                        .then((response) => {
                            this.nodes = response.data.nodes;
                            this.clinks = response.data.clinks;
                            this.renderChart(this.$refs.tree, this.nodes, this.clinks)
                        });
                }else{
                    axios.get('/api/projects/'+this.project+'/get-orgchart'+aloneUrl)
                    .then((response) => {
                        this.nodes = response.data.nodes;
                        this.renderChart(this.$refs.tree, this.nodes)
                    });
                }
            }
      },
      mounted(){
        this.getNodes();
        this.renderChart(this.$refs.tree, this.nodes)
      },
      created(){
        this.isComponentLoaded = false
      },
      updated(){
        this.isComponentLoaded = true
      },
      props: {
        project: {
            type: String,
            required: false
        },
        base_url : {
            type:String,
            required : true
        },
        details_url : {
            type:String,
            required : true
        },
        alone_root : {
            type:Number,
            required : false
        },
        first_collapse : {
            type:Number,
            required : false,
            default : 2,
        },
        print_all_url : {
            type:String,
            required : true
        },
      }
    }
</script>

<style scoped>
</style>
<style>
    #tree {
        width:100% !important
    }
    #org-container{
        text-align: center;
    }
    .message{
        padding: 20px;
    }
</style>
